import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import TutoringComponent from './components/TutoringComponent';

const Tutoring = () => {
  return renderComponent(<TutoringComponent />);
};

export default Tutoring;
